import { useState } from "react";
import shopifyFaqs from "../../data/shopifyFaqs-ny.json";

export default function Section8() {
  const faqs = shopifyFaqs;

  const [isOpen, setIsOpen] = useState(
    new Array(faqs.length).fill(false)
  );

  const handleFaq = (index) => {
    setIsOpen((prev) =>
      prev.map((item, idx) =>
        idx === index ? !item : false
      )
    );
  };

  return (
    <div className="w-full mt-[14%] md:mt-[4%]">
      <div className="w-full">
        
        {/* Heading */}
        <div className="w-[90%] md:w-[61%] pb-[1%] mx-auto text-center">
          <h2 className="leading-[29px] md:leading-[41px] text-[24px] md:text-[34px] text-[#151515] font-bold my-[0.67em]">
            Shopify FAQs
          </h2>
        </div>

        {/* FAQ Section */}
        <div className="w-full md:w-[784px] p-5 md:p-[2%] mx-auto font-open leading-[21px]">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="text-[11px] md:text-sm rounded-[8px] p-[2%] border border-[#DEDEDE] mb-[4%]"
              style={{
                background:
                  "linear-gradient(0deg, #FEFFFF, #FEFFFF), linear-gradient(0deg, #DEDEDE, #DEDEDE)",
              }}
            >
              
              {/* Question */}
              <div
                onClick={() => handleFaq(index)}
                className="text-[#444444] cursor-pointer flex justify-between items-center"
              >
                <span>{faq.q}</span>

                <b className="text-[32px] md:text-[40px] text-[#DA2128] font-[300]">
                  {isOpen[index] ? "−" : "+"}
                </b>
              </div>

              {/* Answer */}
              {isOpen[index] && (
                <div className="text-[#444444] mt-3">
                  {Array.isArray(faq.a) ? (
                    faq.a.map((line, i) => (
                      <p key={i} className="mb-3">
                        {line}
                      </p>
                    ))
                  ) : (
                    <p className="mb-3">{faq.a}</p>
                  )}
                </div>
              )}
            </div>
          ))}
        </div>

      </div>
    </div>
  );
}